import { createRouter, createWebHistory } from 'vue-router'
import { useCookies } from "vue3-cookies";
import * as axios from 'axios';
import { required } from '@vuelidate/validators';

const { cookies }                     = useCookies();
const dashboard                       = require('./dashboard');
const login                           = require('./login');
const modules                         = require('./modules');
const role                            = require('./role');
const log                             = require('./log');
const satuan                          = require('./satuan');
const jenis_hama                      = require('./jenis_hama');
const calendar_inspeksi               = require('./calendar_inspeksi');
const perusahaan                      = require('./perusahaan');
const propinsi                        = require('./propinsi');
const kabupaten_kota                  = require('./kabupaten_kota');
const pegawai                         = require('./pegawai');
const kategori                        = require('./kategori');
const consumable_equipment            = require('./consumable_equipment');
const item_inventory                  = require('./item_inventory');
const pemasukan                       = require('./pemasukan');
const pengeluaran                     = require('./pengeluaran');
const list_project                    = require('./list_project');
const outlet                          = require('./outlet');
const brand                          = require('./brand');
const jadwal_teknisi                  = require('./jadwal_teknisi');
const alat_inspeksi                   = require('./alat_inspeksi');
const list_inventory                  = require('./list_inventory');
const pemasukan_equipment             = require('./pemasukan_equipment');
const pengeluaran_equipment           = require('./pengeluaran_equipment');
const retur_equipment                 = require('./retur_equipment');
const permintaan_teknisi              = require('./permintaan_teknisi');
const supplier                        = require('./supplier');
const pattern                         = require('./pattern');
const penomoran                       = require('./penomoran');
const unit_monitoring                 = require('./unit_monitoring');
const rekomendasi                     = require('./rekomendasi');
const complaint                       = require('./complaint');
const invoice                         = require('./invoice');
const laporan_treatment               = require('./laporan_treatment');
const laporan_pemasukan_consumable    = require('./laporan_pemasukan_consumable');
const laporan_pemasukan_equipment     = require('./laporan_pemasukan_equipment');
const laporan_pengeluaran_consumable  = require('./laporan_pengeluaran_consumable');
const laporan_pengeluaran_equipment   = require('./laporan_pengeluaran_equipment');
const laporan_permintaan_teknisi      = require('./laporan_permintaan_teknisi');
const laporan_pemakaian_consumable    = require('./laporan_pemakaian_consumable');
const ulm_inside_outside              = require('./ulm_inside_outside');
const stok_inventory_teknisi          = require('./stok_inventory_teknisi');

const routes = [
  dashboard.data,
  login.post,
  modules.list,
  modules.show,
  role.group,
  role.group_show,
  role.user,
  role.user_show,
  role.user_customer,
  role.user_customer_show,
  role.group_cabang,
  role.group_cabang_show,
  role.user_edit_password,
  role.administrator,
  role.administrator_show,
  log.list,
  satuan.list,
  satuan.show,
  jenis_hama.list,
  jenis_hama.show,
  calendar_inspeksi.list,
  calendar_inspeksi.show,
  perusahaan.list,
  perusahaan.show,
  propinsi.list,
  propinsi.show,
  kabupaten_kota.list,
  kabupaten_kota.show,
  pegawai.list,
  pegawai.show,
  kategori.list,
  kategori.show,
  consumable_equipment.list,
  consumable_equipment.show,
  item_inventory.list,
  item_inventory.show,
  pemasukan.list,
  pemasukan.show,
  pengeluaran.list,
  pengeluaran.show,
  list_project.list,
  list_project.show,
  outlet.list,
  outlet.show,
  brand.list,
  brand.show,
  jadwal_teknisi.list,
  jadwal_teknisi.show,
  alat_inspeksi.list,
  alat_inspeksi.show,
  list_inventory.list,
  list_inventory.show,
  pemasukan_equipment.list,
  pemasukan_equipment.show,
  pengeluaran_equipment.list,
  pengeluaran_equipment.show,
  retur_equipment.list,
  retur_equipment.show,
  permintaan_teknisi.list,
  permintaan_teknisi.show,
  supplier.list,
  supplier.show,
  pattern.list,
  pattern.show,
  penomoran.list,
  penomoran.show,
  unit_monitoring.list,
  unit_monitoring.show,
  rekomendasi.list,
  rekomendasi.show,
  complaint.list,
  complaint.show,
  invoice.list,
  invoice.show,
  laporan_treatment.list,
  laporan_pemasukan_consumable.list,
  laporan_pemasukan_equipment.list,
  laporan_pengeluaran_consumable.list,
  laporan_pengeluaran_equipment.list,
  laporan_permintaan_teknisi.list,
  laporan_pemakaian_consumable.list,
  ulm_inside_outside.list,
  ulm_inside_outside.show,
  stok_inventory_teknisi.list,
  stok_inventory_teknisi.show
];

const router = createRouter({
    history: createWebHistory(),
    routes
})
router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})


router.beforeEach(async(routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  if (!authRequired) {
    if ((cookies.isKey("refresh_token") == true && cookies.get('refresh_token') !== null) && routeTo.path == "/login") {
      next({ name: "dashboard" });
    } else {
      next();
    }
  } else {
    if (cookies.isKey("refresh_token") == true && cookies.get('refresh_token') !== null) {
      if (routeTo.path == "/login") {
        next({ name: "dashboard" });
      } else {
        next();
      }
    } else {
      next({ name: "login" , query: { redirectFrom: routeTo.fullPath } });
    }
  }
})

export default router
